import axios from 'axios'
import pageKeys from '../common/pagekeys'

export default {
    async getCategories() {
        try{            
            const response = await axios.get(`EDocument/categories`, {
                headers: {
                    'page_key': pageKeys.edocuments
                }
            })                     
            return response
        }catch (error){
            console.log('EDocument api getCategories error')
            throw error
        }
    },
    async getSummary() {
        try{            
            const response = await axios.get(`EDocument/summary`, {
                headers: {
                    'page_key': pageKeys.edocuments
                }
            })                     
            return response
        }catch (error){
            console.log('EDocument api getSummary error')
            throw error
        }
    },
    async getDetails(documentId) {
        try{            
            const response = await axios.get(`EDocument/details/${documentId}`, {
                headers: {
                    'page_key': pageKeys.edocuments
                }
            })                     
            return response
        }catch (error){
            console.log('EDocument api getDetails error')
            throw error
        }
    },
    async getPreSignedUrl(data, pageKey) {
        try{            
            const response = await axios.post(`EDocument/pre-signed-url`, data, {
                headers: {
                    'page_key': pageKey
                }
            })                     
            return response
        }catch (error){
            console.log('EDocument api getPreSignedUrl error')
            throw error
        }
    },
    async addHeader(data) {
        try{            
            const response = await axios.post(`EDocument/header`, data, {
                headers: {
                    'page_key': pageKeys.edocuments
                }
            })                     
            return response
        }catch (error){
            console.log('EDocument api addHeader error')
            throw error
        }
    },
    async updateHeader(data) {
        try{            
            const response = await axios.patch(`EDocument/header`, data, {
                headers: {
                    'page_key': pageKeys.edocuments
                }
            })                     
            return response
        }catch (error){
            console.log('EDocument api updateHeader error')
            throw error
        }
    },
    async addVersion(data) {
        try{            
            const response = await axios.post(`EDocument/version`, data, {
                headers: {
                    'page_key': pageKeys.edocuments
                }
            })                     
            return response
        }catch (error){
            console.log('EDocument api addVersion error')
            throw error
        }
    },
    async updateVersion(data) {
        try{            
            const response = await axios.patch(`EDocument/version`, data, {
                headers: {
                    'page_key': pageKeys.edocuments
                }
            })                     
            return response
        }catch (error){
            console.log('EDocument api updateVersion error')
            throw error
        }
    },
    async deleteFile(data) {
        try{            
            const response = await axios.post(`EDocument/upload/delete-file`, data,
            {
                headers: {
                    'page_key': pageKeys.edocuments
                }
            })            
            return response
        }catch (error){
            console.log('EDocument api deleteFile error')
            throw error
        }
    },
    async publishVersion(data) {
        try{            
            const response = await axios.post(`EDocument/version/publish`, data,
            {
                headers: {
                    'page_key': pageKeys.edocuments
                }
            })
            return response
        }catch (error){
            console.log('EDocument api publishVersion error')
            throw error
        }
    },
    async cancelVersion(data) {
        try{            
            const response = await axios.post(`EDocument/version/cancel`, data,
            {
                headers: {
                    'page_key': pageKeys.edocuments
                }
            })
            return response
        }catch (error){
            console.log('EDocument api cancelVersion error')
            throw error
        }
    },
    async getMyEDocuments() {
        try{            
            const response = await axios.get(`EDocument/MyEDocuments`,
            {
                headers: {
                    'page_key': pageKeys.my_edocuments
                }
            })
            return response
        }catch (error){
            console.log('EDocument api getMyEDocuments error')
            throw error
        }
    },
    async hasNoResponse() {
        try{            
            const response = await axios.get(`EDocument/has-no-response`,
            {
                headers: {
                    'page_key': pageKeys.my_edocuments
                }
            })
            return response
        }catch (error){
            console.log('EDocument api hasNoResponse error')
            throw error
        }
    },
    async submitResponse(data) {
        try{            
            const response = await axios.post(`EDocument/submit-response`, data, {
                headers: {
                    'page_key': pageKeys.my_edocuments
                }
            })                     
            return response
        }catch (error){
            console.log('EDocument api submitResponse error')
            throw error
        }
    },
}